"use client";

/**
 * ThumbImg — the one way a grid tile paints a thumbnail (founder 08-04: the
 * grid's raw progressive half-paint read as broken). The theme shimmer holds
 * the tile until the image has DECODED, then the image fades in; a browser-
 * cached image (stable transform URLs made that the common case) skips the
 * fade entirely via the `complete` check, so revisits paint instantly.
 * Parent must be `position: relative` — the shimmer fills it.
 */

import { useState } from "react";
import { cn } from "@/lib/utils";

export function ThumbImg({
  src,
  alt,
  className,
  shimmerClassName = "",
  onError,
}: {
  src: string;
  alt: string;
  className: string;
  shimmerClassName?: string;
  onError?: () => void;
}) {
  const [ready, setReady] = useState(false);
  return (
    <>
      {!ready && (
        <div
          className={cn(
            "absolute inset-0 bg-shimmer-elevated bg-[size:200%_100%] animate-shimmer",
            shimmerClassName
          )}
          aria-hidden
        />
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        ref={(el) => {
          if (el && el.complete && el.naturalWidth > 0) setReady(true);
        }}
        onLoad={() => setReady(true)}
        onError={() => {
          setReady(true);
          onError?.();
        }}
        className={`${className} transition-opacity duration-300 ${
          ready ? "opacity-100" : "opacity-0"
        }`}
      />
    </>
  );
}
